import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material';
import { UserService } from '../../../../services/user.service';
import { ReportService } from '../../../../services/report.service';
import { saveAs } from 'file-saver/FileSaver';

@Component({
  selector: 'app-swk-government',
  templateUrl: './swk-government.component.html',
  styleUrls: ['./swk-government.component.css']
})
export class PukalAccountReportsSwkGovernmentComponent implements OnInit, OnDestroy {
  warrant_auth_code: string = 'SW';
  allSub: Subscription[] = [];
  swkpukalaccrptform: FormGroup;
  errorMessage: string = '';
  downloadMessage: string = '';
  exportFileTypes = [];
  loading: boolean = false;
  isSubmit: boolean = false;
  userName: string = '';
  screenCode: string = '';

  constructor(public snackBar: MatSnackBar,
    private userService: UserService,
    private reportService: ReportService) {
    let user = this.userService.getUser();
    this.userName = user.username;
    this.screenCode = user.screenCode;
  }

  ngOnInit() {
    this.swkpukalaccrptform = new FormGroup({
      exportfiletype: new FormControl({ value: '', disabled: false }, [Validators.required])
    });

    this.loading = true;
    let init_sub = this.reportService.getInitPukalAccReports()
      .subscribe(
        (value) => {
          this.loading = false;
          this.exportFileTypes = value.body['exportFileTypeDT'];

          this.swkpukalaccrptform.setValue({
            exportfiletype: value.body['exportFileTypeDT'][0].VALUE
          });
        },
        (error) => {
          this.errorMessage = <any>error;
          this.openSnackBar(this.errorMessage, '');
        });

    //Adds into array for each subscribe
    this.allSub.push(init_sub);
  }

  onSubmit(form: FormGroup) {
    this.isSubmit = true;
    this.downloadMessage = 'System is generating report....';

    let pukalAccount = {
      Export_File_Type: this.swkpukalaccrptform.get('exportfiletype')!.value
    }

    let save_sub = this.reportService.downloadSwkPukalAccReports(pukalAccount)
      .subscribe(
        (value) => {
          if (value.status === 204) {
            this.isSubmit = false;
            this.openSnackBar('Download failed.', '');
          } else if (value.status === 200) {
            if (pukalAccount.Export_File_Type === '.xls') {
              let blob = new Blob([value.body], { type: 'application/vnd.ms-excel' });
              saveAs(blob, 'SWK Pukal Account.xls');
            } else if (pukalAccount.Export_File_Type === '.pdf') {
              let blob = new Blob([value.body], { type: 'application/pdf' });
              saveAs(blob, 'SWK Pukal Account.pdf');
            }

            this.openSnackBar('Report Created.', '');
            this.isSubmit = false;
          } else {
            this.isSubmit = false;
            this.openSnackBar('Download failed.', '');
          }
        },
        (error) => {
          this.errorMessage = <any>error;
          this.isSubmit = false;
          this.openSnackBar(this.errorMessage, '');
        });

    //Adds into array for each subscribe
    this.allSub.push(save_sub);
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    });
  }

  ngOnDestroy() {
    for (let sub of this.allSub) {
      sub.unsubscribe();
    }
  }
}
